<template>
  <v-card>
    <v-card-text>
      <template v-for="(header, headerIndex) in headers">
        <v-layout :key="header.value">
          <v-flex xs4>
            <span class="grey--text text--darken-1">{{ header.text }}</span>
          </v-flex>
          <v-flex xs8>
            <device-site
              v-if="header.value == 'site_sortkey'"
              :device="device"
              :icon="false"
            />
            <device-decodertype
              v-if="header.value == 'decodertype'"
              :device="device"
            />
            <div v-if="header.value == 'description'">
              <device-description :device="device" />
              <img
                v-if="device.is_new"
                :src="$store.state.common.newBadgeURL"
                style="position: absolute; top: -4px; right: -4px; z-index: 0"
              >
            </div>
            <device-addresses
              v-if="header.value == 'deviceAddress'"
              :device="device"
            />
            <device-status
              v-if="header.value == 'online_sortkey'"
              :device="device"
            />
            <device-last-online
              v-if="header.value == 'last_online_sortkey'"
              :device="device"
            />
            <device-actions
              v-if="header.value == 'actions'"
              :device="device"
              icon="more_horiz"
              @renamed="$emit('renamed')"
            />
          </v-flex>
        </v-layout>
        <v-divider
          v-if="headerIndex < headers.length - 1"
          :key="'divider-' + headerIndex"
          class="my-1"
        />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import DeviceActions from '@/components/Device/DeviceActions';
import DeviceAddresses from '@/components/Device/DeviceAddresses';
import DeviceDecodertype from '@/components/Device/DeviceDecodertype';
import DeviceDescription from '@/components/Device/DeviceDescription';
import DeviceLastOnline from '@/components/Device/DeviceLastOnline';
import DeviceSite from '@/components/Device/DeviceSite';
import DeviceStatus from '@/components/Device/DeviceStatus';

export default {
  components: {
    DeviceActions,
    DeviceAddresses,
    DeviceDecodertype,
    DeviceDescription,
    DeviceLastOnline,
    DeviceSite,
    DeviceStatus,
  },
  props: {
    /** It's basically a serialized Radio-/TVDecoder.
     *
     * Does have extra attributes though due to augmentation to e.g.
     * improve sortability within the v-data-table.
     */
    device: {
      type: Object,
      required: true,
    },
    headers: {
      type: Array[Object],
      required: true,
    },
    isSlave: {
      type: Boolean,
      default: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Device/DeviceCard.vue